import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SchemaMetaFormComponent } from '../schema-meta-form/schema-meta-form.component';
import { TranslatePipe } from '@ngx-translate/core';
import { EMPTY_SCHEMA_META_TEMPLATE, isValidSchemaMetaTemplate, SchemaMetaTemplate } from '../schema-meta.model';
import { deepCopy } from 'na-lib';

@Component({
  selector: 'app-schema-meta-template-dialog',
  templateUrl: './schema-meta-template-dialog.component.html',
  styleUrls: ['./schema-meta-template-dialog.component.css'],
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, SchemaMetaFormComponent, TranslatePipe]
})
export class SchemaMetaTemplateDialogComponent {
  metaTemplate: SchemaMetaTemplate;

  constructor(
    public dialogRef: MatDialogRef<SchemaMetaTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: { metaTemplate?: SchemaMetaTemplate }
  ) {
    this.metaTemplate = deepCopy(data?.metaTemplate || EMPTY_SCHEMA_META_TEMPLATE);
  }

  updateMetaTemplate(metaTemplate: SchemaMetaTemplate): void {
    this.metaTemplate = deepCopy(metaTemplate);
  }

  get canSave(): boolean {
    return isValidSchemaMetaTemplate(this.metaTemplate);
  }

  save(): void {
    if (!this.canSave) return;
    this.dialogRef.close([true, this.metaTemplate]);
  }
}
